export default "__VITE_ASSET__DZhJWXx0__"